import { CircularProgress } from '@llt-frontend/react-material-progress';
import PropTypes from 'prop-types';
import React from 'react';
import { Select } from '@llt-frontend/react-material-select';
import { useFetch } from '@llt-frontend/react-fetch';
import { useTranslation } from 'react-i18next';
// Components

export function GradeLevelSelect({ excludedIds = [21], onChange, savedValue }) {
  const { t, ready: translationLoaded } = useTranslation(
    'self-service/packages/grade-level-select'
  );

  const gradeLevelsApiPath = `${process.env.REACT_APP_API_HOST}/vtwa/v2/config/grade_list`;
  const gradeLevels = useFetch(gradeLevelsApiPath);

  const [initialValue] = React.useState(savedValue);

  function getGradeLevels() {
    if (gradeLevels.status === 'loading') {
      return [
        {
          primaryText: translationLoaded && t('loading'),
        },
      ];
    }

    if (!gradeLevels.data) {
      return [
        {
          className: 'mdc-list-item--error',
          primaryText: translationLoaded && t('loadError'),
        },
      ];
    }

    return gradeLevels.data
      .filter(({ id }) => !excludedIds.includes(id))
      .sort((a, b) => a.id - b.id)
      .map(({ id, name }) => ({
        primaryText: name,
        value: id.toString(),
      }));
  }

  if (!gradeLevels.data && initialValue) {
    return (
      <div className="package-selector__grade-select__loading">
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className="package-selector__grade-select">
      <label className="select-label">{translationLoaded && t('studentsGrade')}</label>
      <Select
        name="select-grade"
        initialValue={initialValue}
        inputClassName="select-grade"
        placeholder={translationLoaded ? t('selectGrade') : ''}
        outlined
        {...{
          options: getGradeLevels(),
          onItemClick: (_, { value }) => onChange && onChange(value),
        }}
      />
    </div>
  );
}
GradeLevelSelect.propTypes = {
  onChange: PropTypes.func,
  excludedIds: PropTypes.arrayOf(PropTypes.number),
};

export default GradeLevelSelect;
